const zhTW = {
  hero: {
    title: "去看更寬廣的世界",
    subtitle: "流暢 4K｜不限流量｜三網優化｜AI 優化",
    free_register: "免費註冊",
  },
  nav: {
    home: "首頁",
    login: "登入",
    signup: "註冊",
    pricing: "價格",
    faq: "常見問題",
    contact: "聯絡我們",
    wechat: "微信客服",
    telegram: "Telegram 電報",
    email: "電子郵件",
    download: "下載客戶端",
    android: "安卓",
    smarttv: "智慧電視",
    userCenter: "用戶中心",
    logout: "登出",
    logoutConfirm: "確定要登出當前帳號嗎？",
  },
  faq: {
    title: "常見問題",
  },
  common: {
    cancel: "取消",
    loading: "處理中…",
    backToHome: "用戶中心",
    close: "關閉",
  },
  wechatModal: {
    title: "客服微信",
    loadError: "暫時無法載入微信二維碼，請稍後重試。",
    description: "掃描二維碼新增客服，或搜尋下方微信號",
  },
  features: {
    title: "為什麼選擇梯子Z",
    subtitle:
      "穩定高速、不限流量、全球覆蓋、自研客戶端、AI 應用優化、智慧分流、專業客服 —— 一站式加速體驗",
    moreLink: "了解更多",
    items: {
      1: {
        title: "流暢 4K｜不限流量",
        desc: "YouTube 任意拖曳，Netflix 奈飛高清即點即播。不限流量，想看多久就看多久",
      },
      2: {
        title: "法國正規企業",
        desc: "註冊於法國巴黎，嚴格遵守歐盟資料法規，讓每位用戶的隱私更加安心",
      },
      3: {
        title: "自研客戶端｜全平臺支援",
        desc: "自研客戶端覆蓋主流平臺，並避免線路與設定資訊外洩，更安全放心",
      },
      4: {
        title: "智慧分流｜AI 專屬優化",
        desc: "中國境內與國外網站自動分流，訪問互不影響。香港線路也可流暢使用各類 AI 應用",
      },
      5: {
        title: "專業客服支援",
        desc: "提供微信、電子郵件等多管道即時協助，遇到問題隨時都能找到我們",
      },
      6: {
        title: "全球高速伺服器",
        desc: "香港、美國、東南亞、歐洲、澳洲、非洲、南美等多地區節點自由選擇",
      },
    },
  },
  pricing: {
    sectionTitle: "方案價格",
    sectionSubtitle: "依照使用時間選擇最適合你的方案，所有方案皆包含完整功能、不限流量與客服支援。",
    labels: {
      perMonth: "月",
      recommended: "推薦",
      savePercent: "立省 {{rate}}%",
      defaultCta: "立即開通",
      cta: {
        open: "立即開通",
        toUserCenter: "查看我的方案",
        renew: "立即續費",
        reopen: "重新開通",
      },
    },
    features: {
      bandwidth: "4K/1080P 高畫質串流頻寬",
      multiDevice: "支援自用多臺裝置同時使用",
      noShare: "禁止共用帳號給其他人",
      streamingUnlock: "部分伺服器可解鎖串流影音服務",
    },
    paymentModal: {
      title: "選擇支付方式 - {{plan}}",
      paymentTitle: "選擇支付方式",
      methods: {
        alipay: "支付寶支付",
        alipayDesc: "使用支付寶掃碼或在手機支付寶中完成支付。",
        wechat: "微信支付",
        wechatDesc: "使用微信掃碼完成支付，支援錢包餘額與綁定銀行卡。",
        card: "信用卡 / 金融卡支付",
        cardDesc: "支援 Visa / MasterCard / 銀聯卡，並可透過 Apple Pay 與 Link 完成支付。",
      },
      noticeActive:
        "續費說明：本次續費會在您當前的到期時間基礎上順延，不會浪費剩餘有效期。例如：如果當前到期日為 2025-12-31，續費成功後將在此日期基礎上再延長對應天數。",
      noticeExpired:
        "開通說明：您的方案目前已過期，本次支付成功後，有效期將從付款成功當天開始重新計算。",
      noticeNew:
        "開通說明：本次為首次開通，方案有效期將從付款成功當天開始計算；後續續費時會在剩餘有效期基礎上順延，不會浪費時間。",
      notice:
        "支付成功後，系統會在 1 分鐘內自動為你開通或續費方案。如遇到問題可透過微信或電子郵件聯繫客服。",
      confirm: "支付",
    },
    priceNote1: "方案以歐元計價，支付寶 / 微信 / 銀聯支付會自動換算成人民幣",
    priceNote2: "信用卡支付也會自動換算為本地幣別，無需歐元帳戶",
    priceNote3: "部分支付渠道會收取約 3%–7% 的額外手續費（由支付平台收取）",
    plans: {
      monthly: {
        tag: "",
        title: "月方案",
        duration: "1 個月",
        discount: "6 折優惠",
        cta: "立即開通",
        features: {
          1: "不限流量使用",
          2: "支援多臺裝置同時在線",
          3: "禁止惡意分享帳號",
          4: "4K / 1080P 影片播放無壓力",
          5: "客服支援（微信 / 電子郵件）",
        },
      },
      yearly: {
        tag: "最受歡迎",
        title: "年方案",
        duration: "1 年",
        discount: "4 折優惠",
        cta: "推薦購買",
        features: {
          1: "不限流量使用",
          2: "支援多臺裝置同時在線",
          3: "4K 影片流暢播放",
          4: "AI 應用專屬線路優化",
          5: "微信一對一技術支援",
        },
      },
      halfyear: {
        tag: "",
        title: "半年方案",
        duration: "6 個月",
        discount: "5.2 折優惠",
        cta: "立即開通",
        features: {
          1: "不限流量使用",
          2: "支援多臺裝置同時在線",
          3: "4K / 1080P 影片播放無壓力",
          4: "全球節點自由切換",
          5: "客服支援（微信 / 電子郵件）",
        },
      },
    },
    loading: "正在進入支付頁面…",
    noPaymentAction: "此支付通道未返回二維碼或跳轉連結，暫時無法繼續支付，請嘗試切換其他支付通道。",
  },
  payments: {
    title: "購買套餐",
    subtitle: "請選擇支付方式與支付通道並完成付款",
    loading: "正在進入支付頁面…",
    noPaymentAction: "此支付通道未返回二維碼或跳轉連結，暫時無法繼續支付，請嘗試切換其他支付通道。",
    alipay: {
      scan: "請使用支付寶掃碼支付",
    },
    wechat: {
      scan: "請使用微信掃碼支付",
    },
    qr: {
      tip: "支付完成後請勿關閉此頁面，系統將自動檢測支付狀態。",
      open: "開啟支付頁面",
    },
    card: {
      enter: "請輸入銀行卡資訊",
      loading: "正在載入支付元件…",
      pay: "確認付款",
      tip: "如需驗證（3D Secure），系統將自動彈出或跳轉完成驗證。",
    },
    polling: "正在檢測支付狀態（每 10 秒重新整理一次）",
    pollingInit: "正在取得支付狀態…",
    pollingStatus: "目前狀態",
    pollingError: "狀態檢查失敗",
    refresh: {
      title: "正在檢測支付狀態（每 10 秒重新整理一次）",
      init: "正在取得支付狀態…",
      status: "目前支付狀態：{{status}}",
      errorPrefix: "狀態檢查失敗",
    },
    successTitle: "支付成功",
    successDesc: "系統已確認付款並完成方案有效期更新。點擊繼續返回用戶中心。",
    continueToUserinfo: "繼續",
    errors: {
      missingShopPk: "缺少方案資訊（shop_pk）",
      missingStripePublicKeyForCheckout: "缺少 Stripe 公鑰，無法啟動 Checkout 支付",
      missingCheckoutSessionId: "缺少 Checkout 工作階段資訊，無法繼續支付",
      stripeJsNotAvailable: "Stripe.js 尚未載入，無法繼續支付",
      redirectToCheckoutFailed: "跳轉至 Stripe Checkout 失敗",
      paymentRequestFailed: "支付請求失敗，請稍後再試",
    },
    payOptions: {
      duration: "時長",
      total: "應付金額",
      methodTitle: "1. 請選擇支付方式",
      providerTitle: "2. 請選擇支付通道",
      processing: "處理中…",
      retry: "重試",
    },
    methods: {
      wechat: "微信支付",
      alipay: "支付寶",
      alipayhk: "支付寶香港",
      card: "銀聯卡/信用卡/金融卡",
    },
    providers: {
      stripeRecommended: "通道一 推薦",
      airwallex: "通道二",
      epay: "備用通道 - 多渠道輪換，如支付失敗可刷新再試",
    },
    notes: {
      wechatNoScreenshotForStripeAirwallex:
        "不支援截圖掃碼：請將二維碼發送到另一台裝置（智慧手錶也可以），再用微信直接掃碼。",
      wechatEpayScreenshotAllowed: "支援截圖掃碼：可將二維碼截圖，透過微信掃描相簿完成支付。",
      unionpayNoExpiryCvcHint:
        "部分銀聯卡未印刷有效期或安全碼（CVC）。如無相關資訊，可填寫有效期 12/30，CVC 000。",
      currencyConversion:
        "方案以歐元計價，支付寶／微信／銀聯支付將自動換算為人民幣；信用卡支付亦會自動換算為本地幣別，無需歐元帳戶。",
    },
    cardChannels: {
      stripeIntent: "Stripe 安全支付 - 推薦；直接輸入銀行卡資訊支付",
      stripeCheckout: "跳轉 Stripe 平台支付，支援 Apple Pay",
    },
  },
  userInfo: {
    welcomeUser: "歡迎回來",
    welcomeGuest: "歡迎來到用戶中心",
    followUs: "關注我們",
    currentPlanTitle: "當前方案",
    planActiveUntil: "當前方案有效期至 {{date}}",
    planInactive: "當前暫無已開通的方案",
    planExpire: "當前方案有效期 - {{date}}",
    planExpireExpired: "當前方案有效期 - {{date}}（已過期）",
    planCta: {
      open: "立即開通方案",
      reopen: "重新開通方案",
      renew: "續費延長有效期",
    },
    viewPlans: "購買方案或續費",
    downloadClientTitle: "下載客戶端",
    downloadClientDescription: "系統偵測到你正在使用 {{os}}，",
    downloadClientLinkLabel: "點擊前往下載",
    downloadOtherClientsLabel: "查看全部應用",
    os: {
      windows: "Windows 裝置",
      macos: "macOS 裝置",
      android: "Android 裝置",
      ios: "iOS 裝置",
      linux: "Linux 裝置",
      unknown: "當前裝置",
    },
    verifyEmail: "確認電子郵件",
    confirmEmail: {
      sending: "發送中…",
      submitError: "確認郵件發送失敗，請稍後重試",
      success: "確認郵件已發送，請查看信箱",
    },
    devices: {
      title: "已連線裝置",
      loading: "正在取得裝置...",
      empty: "暫無已連線客戶端裝置",
      fetchError: "裝置資訊取得失敗，請稍後重試",
      unknownDevice: "未知裝置",
      unknownVersion: "未知版本",
      summaryWithLatest: "{{count}}/{{limit}} 台裝置，最近：{{device}} · {{version}}",
      manage: "管理",
      disconnect: "斷開",
      disconnecting: "斷開中...",
      disconnectError: "斷開裝置失敗，請稍後重試",
      modalTitle: "管理已連線裝置",
      modalSummary: "目前 {{count}}/{{limit}} 台裝置保持連線",
      lastSeen: "最近在線 {{time}}",
      expiresAt: "登入有效期至 {{time}}",
    },
    changePassword: "修改密碼",
    passwordModal: {
      title: "修改密碼",
      oldPassword: "目前密碼",
      newPassword: "新密碼",
      confirmPassword: "確認新密碼",
      cancel: "取消",
      submit: "確認修改",
      submitting: "修改中…",
      missingFields: "請填寫目前密碼、新密碼和確認新密碼",
      passwordMismatch: "兩次輸入的新密碼不一致",
      submitError: "修改密碼失敗，請稍後重試",
      success: "密碼已修改，請重新登入",
    },
    appleId: "Apple ID",
    thirdPartyLinks: "訂閱連結",
    subscriptionModal: {
      title: "訂閱連結",
      description:
        "訂閱連結僅限本人使用，嚴禁分享。一旦系統偵測到分享行為，帳號將被立即停用且無法解封。",
      clashDescription: "【佔位】這裡是 Clash 連結說明文案，請按需替換。",
      loading: "正在取得訂閱連結...",
      fetchError: "取得訂閱連結失敗，請稍後重試",
      copyError: "複製失敗，請手動複製",
      retry: "重試",
      copyButton: "複製連結",
      copied: "已複製",
      tabs: {
        subscription: "訂閱連結",
        clash: "Clash",
      },
      compatibleApps: {
        subscription: "適用於 Shadowrocket, V2rayNG Android, V2rayN Windows & macOS",
        clash: "適用於 Clash, OpenClash；在瀏覽器中開啟連結，可直接下載 YAML 設定",
      },
      primaryLabel: "主訂閱連結",
      backupLabel: "備用訂閱連結",
      hoverToReveal: "滑鼠懸停此處顯示訂閱連結",
      hoverHint: "安全提示：離開該區域後會自動隱藏連結內容",
    },
    appList: {
      title: "全部應用",
      subtitle:
        "我們提供自研客戶端覆蓋主流平臺，同時也支援常見的第三方應用，方便你在各種裝置上使用 ZionLadder。",
      downloadLink: "前往下載",
      setupLink: "前往設定",
      comingSoon: "即將發布",
      ios: {
        title: "Apple iOS",
        description: "支援 iPhone、iPad 和搭載 Apple M 系列晶片的 Mac",
      },
      macos: {
        title: "Apple macOS",
        description: "支援 macOS 10.15+ 的 Intel Mac 與 macOS 11+ 的 Apple M 系列 Mac",
      },
      android: {
        title: "Android",
        description: "支援多數 Android 手機、平板與電腦，以及華為鴻蒙系統上的卓易通和出境易",
      },
      windows: {
        title: "Windows",
        description: "適用於 Windows 7 x64 與 Windows 10/11+ 系統的電腦",
      },
      appletv: {
        title: "Apple TV",
        description: "適用於運行 tvOS 系統的 Apple TV 裝置",
      },
      smarttv: {
        title: "智慧電視（Smart TV）",
        description: "適用於 Android 系統的智慧電視",
      },
      openwrt: {
        title: "OpenWrt 路由器",
        description: "適用於刷入 OpenWrt 韌體的路由器裝置",
      },
      linux: {
        title: "Linux",
        description: "適用於常見 Linux 發行版的桌面或伺服器環境",
      },
      thirdParty: {
        title: "第三方應用",
        description:
          "適用於 Shadowrocket, V2rayN, V2rayNG, Open Clash, Clash, OpenWrt, Passwall, 梅林...",
      },
    },
  },
  clients: {
    ios: {
      softwareName: "iOS 客戶端名稱佔位",
      supportedDevices: "適用裝置：iPhone / iPad",
      version: "目前版本：v1.0.0",
      currentVersionLabel: "目前版本",
      getSharedAppleId: "取得共用 Apple ID",
      desc: {
        title: "使用說明",
        section1Title: "基本功能",
        section1Body:
          "1. 應用介面右上角的購買按鈕可用於帳號儲值。\n2. 點擊重新整理按鈕可取得最新線路清單。\n3. 點擊分享按鈕可將線路共享到區域網路裝置。\n4. 點擊對話按鈕可聯繫微信客服。\n\n分流模式對應不同的分流策略：\n1. 智慧分流：依國內與國外網站分流，僅國外網站透過線路存取。\n2. 全域模式：所有流量都透過線路存取，可能影響國內應用體驗。",
        section2Title: "選擇線路",
        section2Body:
          "請依你的網路環境與使用需求選擇線路。右側綠色標籤會標示適合的電信業者與線路類型。\n選擇線路後，再點擊上圖中的【連線】按鈕，即可透過梯子Z存取網際網路。",
      },
      usage: {
        title: "使用說明",
        step1: "使用共用 Apple ID 登入 App Store，切換到海外商店",
        step2: "下載並安裝 ZionLadder（梯子Z）App",
        step3: "選擇合適的分流方式與線路，注意電信業者匹配；海外或港澳台建議選擇直連",
        step4: "點擊連線，開始使用服務",
      },
    },
    sharedid: {
      title: "共用 Apple ID",
      titleLoginRequired: "需要登入",
      titlePaidRequired: "需要購買方案",
      titleRenewRequired: "需要續費",
      titleNoAppleId: "暫未分配",
      titleFetchFailed: "取得失敗",

      loading: "正在取得共用 Apple ID…",
      okHint: "請在 App Store 登入時使用以下帳號與密碼。",
      errorNetwork: "網路異常或伺服器錯誤，請稍後再試",

      actionLogin: "去登入",
      actionBuy: "去購買方案",
      actionRenew: "去續費",

      labelAppleId: "Apple ID",
      labelPassword: "密碼",
      copied: "已複製",

      tip: "重要說明：\n1. 如果你已有外區 Apple ID，可直接使用外區 ID 下載 ZionLadder 軟體，無需使用共用 Apple ID\n2. 共用 Apple ID 僅供登入 App Store 使用，登入過程請勿綁定手機號，並請嚴格依照我們的圖文說明操作\n3. 共用 Apple ID 僅用於下載 App 時的臨時登入，下載完成後請務必登出帳號，且不要用於儲值或訂閱其他產品；如發現違規使用，我們將立即回收該帳號",
      imageHint: "請參考下方圖文說明，依步驟完成操作",
      imageDesc:
        "打開 App Store（應用商店）：\n1. 點擊右上角的頭像\n2. 下滑到頁面最底部，點擊【登出】\n3. 使用共用 Apple ID 登入\n4. 在彈出選單中，選擇【不是 XXX】\n5. 輸入共用 Apple ID 與密碼\n6. 在 Apple 帳號安全選單中，選擇【其他選項】\n7. 在彈出的「保護你的帳號」視窗中，選擇【不升級】\n完成共用 Apple ID 登入",
    },
    android: {
      softwareName: "Android 客戶端名稱佔位",
      supportedDevices: "適用裝置：Android 手機、平板、電腦｜鴻蒙卓易通、出境易",
      version: "目前版本：v1.0.0",
      currentVersionLabel: "目前版本",
      downloadApp: "下載應用",
      backupDownload: "備用下載",
      desc: {
        title: "使用說明",
        section1Title: "基本功能",
        section1Body:
          "1. 應用介面右上角的購買按鈕可用於帳號儲值。\n2. 點擊重新整理按鈕可取得最新線路清單。\n3. 點擊分享按鈕可將線路共享到區域網路裝置。\n4. 點擊對話按鈕可聯繫微信客服。\n\n分流模式對應不同的分流策略：\n1. 智慧分流：依國內與國外網站分流，僅國外網站透過線路存取。\n2. 全域模式：所有流量都透過線路存取，可能影響國內應用體驗。",
        section2Title: "選擇線路",
        section2Body:
          "請依你的網路環境與使用需求選擇線路。右側綠色標籤會標示適合的電信業者與線路類型。\n選擇線路後，再點擊上圖中的【連線】按鈕，即可透過梯子Z存取網際網路。",
      },
      usage: {
        title: "使用說明",
        step1: "下載並安裝應用（APK 或應用商店）",
        step2: "開啟應用並登入帳號",
        step3: "選擇節點並連線",
        step4: "開始使用服務",
      },
    },
    windows: {
      softwareName: "Windows 客戶端名稱佔位",
      supportedDevices: "適用裝置：Windows 7 x64、Windows 10/11+",
      version: "目前版本：v1.0.0",
      currentVersionLabel: "目前版本",
      downloadInstaller: "下載安裝程式",
      downloadPortable: "下載免安裝版",
      desc: {
        title: "使用說明",
        section1Title: "安裝梯子Z應用",
        section1Body:
          "執行下載的安裝檔。若遇到安全性提示，請點擊「更多資訊」，再點擊「仍要執行」，完成安裝。",
        section2Title: "基本操作",
        section2Body:
          "右上角功能區：\n1. 購物車按鈕：可為梯子Z帳號續費。\n2. 重新整理按鈕：取得最新線路清單。\n3. 分享按鈕：可將線路共享到區域網路。\n4. 微信按鈕：新增微信客服。",
        section2RoutingTitle: "分流模式說明",
        section2RoutingBody:
          "1. 智慧分流：依國內與國外網站分流，僅國外網站透過線路存取。\n2. 全域模式：所有流量都透過線路存取，可能影響國內應用體驗。",
        section3Title: "選擇線路",
        section3Body:
          "請依你的網路環境與使用需求選擇線路。右側綠色標籤會標示適合的電信業者與線路類型。\n選擇線路後，再點擊上圖中的【連線】按鈕，即可透過梯子Z存取網際網路。",
      },
      usage: {
        title: "使用說明",
        step1: "下載並安裝客戶端",
        step2: "開啟客戶端並登入帳號",
        step3: "選擇節點並連線",
        step4: "開始使用服務",
      },
    },
    macos: {
      softwareName: "macOS 客戶端名稱佔位",
      supportedDevices: "適用裝置：Mac 桌面 / 筆電 - macOS 10.15+",
      version: "目前版本：v1.0.0",
      currentVersionLabel: "目前版本",
      downloadApp: "下載應用",
      backupDownload: "備用下載",
      usage: {
        title: "使用說明",
        step1: "下載並安裝客戶端",
        step2: "開啟客戶端並登入帳號",
        step3: "選擇節點並連線",
        step4: "開始使用服務",
      },
    },
    third: {
      title: "第三方應用設定",
      hero: {
        title: "第三方應用",
        apps: "Shadowrocket, V2rayN for Windows/macOS, V2rayNG Android, 梅林, OpenWrt, Passwall, Clash系列",
        subscribeButton: "訂閱連結",
        usage: {
          title: "使用說明",
          step1: "根據設備，下載合適的應用",
          step2: "新增適用於該應用的訂閱連結",
          step3: "不要使用第三方線上訂閱轉換，會導致線路資訊洩漏，洩漏線路資訊的帳號會被封停",
        },
      },
      quick: {
        title: "快速配置",
        subtitle: "複製你的專屬訂閱地址，並選擇合適客戶端進行導入。",
        loading: "正在取得訂閱地址...",
        inputPlaceholder: "暫無可用訂閱地址",
        revealButton: "顯示",
        hideButton: "隱藏",
        copyButton: "複製",
        copied: "已複製",
        hint: "訂閱地址預設打碼顯示，點擊顯示後可查看完整地址。",
        fetchError: "取得訂閱地址失敗，請稍後重試",
        copyError: "複製失敗，請手動複製",
      },
      recommendHint: "請依照你的裝置選擇合適的客戶端下載與導入。",
      sourceTabs: {
        label: "訂閱來源",
        hint: "若主用訂閱失敗，請嘗試備用。",
        main: "主用",
        backup: "備用",
        backupMissing: "目前未設定備用訂閱連結，請切回主用網域。",
      },
      buttons: {
        download: "下載",
        appStore: "App Store",
        copySub: "複製訂閱",
        oneClickImport: "一鍵導入",
        copied: "已複製",
      },
      platforms: {
        windows: "Windows",
        macos: "macOS",
        android: "Android",
        ios: "iOS",
        linux: "Linux",
        router: "路由器",
      },
      platformNotes: {
        macos: "安裝提示：如無法安裝，請在終端執行 sudo spctl --master-disable",
        ios: "iOS 客戶端需在 App Store 購買或下載，請使用非中國區 Apple ID",
      },
      apps: {
        clashVerge: "功能強大的圖形化客戶端（推薦）",
        clashVergeMacTips: "若訂閱報錯請更新到最新版客戶端；持續報錯請先關閉現有代理",
        clashParty: "若訂閱報錯請更新到最新版客戶端",
        v2rayn: "輕量級 V2Ray 客戶端",
        v2raynMac: "若提示檔案損壞，請在終端執行：xattr -cr /Applications/v2rayN.app",
        v2rayu: "若提示無法開啟，請在終端執行：sudo spctl --master-disable",
        nekoray: "支援多種協議的桌面客戶端",
        singbox: "通用代理平台，支援最新協議",
        clashNyanpasu: "增強版 Clash 客戶端",
        flclash: "Flutter 開發的現代化客戶端",
        clashmi: "基於 Mihomo 內核的新客戶端",
        clashmiFreeIos: "免費的 iOS Clash 客戶端，使用 Clash 訂閱",
        hiddify: "易用的多協議客戶端",
        sfm: "sing-box 官方 macOS 客戶端",
        sfa: "sing-box 官方 Android 客戶端",
        sfi: "sing-box 官方 iOS 客戶端",
        cmfa: "Android 平台 Clash 客戶端",
        cmfaTips: "若更新訂閱出現 EOF 錯誤，請先斷開該設定檔連線再更新",
        v2rayng: "Android 平台 V2Ray 客戶端",
        nekobox: "支援多協議的 Android 客戶端",
        shadowrocket: "專業 iOS 客戶端（需於 App Store 購買）",
        shadowrocketTips: "若訂閱失敗或測速全紅，請更新到最新版 Shadowrocket",
        stash: "功能豐富的 iOS 客戶端",
        loon: "支援規則分流的 iOS 客戶端",
        loonTips: "Loon 訂閱時請在設定頁開啟解析器開關",
        quantumultx: "請更新到最新版 QX，並啟用資源解析器（版本不低於 1.5.5）",
        v2raya: "Web 介面的 V2Ray 客戶端",
        qv2ray: "Qt 跨平台客戶端",
        openclash: "OpenWrt 路由器 Clash 外掛",
        openclashTips: "如出現 GEOsite 報錯，請將 GEO 庫切換為 FULL 版本",
        passwall: "OpenWrt 路由器多協議代理外掛",
        passwallTips: "若出現報錯請改用下方 Passwall2",
        passwall2: "出現報錯請更新至最新版",
        ssrplus: "必須更新到最新版外掛，舊版不支援 VLESS 協議",
        merlin: "梅林韌體常用代理外掛方案",
        merlin2: "GeoIP/GeoSite 請切換為 FULL 版本後使用",
      },
    },
  },
  manageAccount: {
    invalidLink: "無效的帳戶連結",
    topupFor: "你正在為以下使用者充值：",
    username: "使用者名稱",
    currentExpire: "當前有效期",
    loading: "查詢中...",
    notActivated: "未充值過",
  },
  auth: {
    signInTitle: "登入",
    signUpTitle: "註冊帳號",
    emailLabel: "電子郵件",
    passwordLabel: "密碼",
    confirmPasswordLabel: "確認密碼",
    rememberMe: "記住登入狀態",
    signInButton: "登入",
    signInButtonLoading: "登入中…",
    signUpButton: "註冊",
    signUpButtonLoading: "註冊中…",
    missingCredentials: "請輸入電子郵件與密碼",
    missingSignupFields: "請輸入電子郵件、密碼與確認密碼",
    passwordMismatch: "兩次輸入的密碼不一致",
    noAccount: "還沒有帳號？",
    signUpLink: "註冊新帳號",
    alreadyHaveAccount: "已經有帳號？",
    goToSignInLink: "前往登入頁面",
    emailExists: "該電子郵件已被註冊",
    signupUnknownError: "註冊失敗，請稍後重試",
  },
};

export default zhTW;
